<template>
  <div class="home">
    <img
      class="logo"
      :src="`${publiPath}/schoolLogo.png`"
      :style="{ width: ismob ? '80%' : 'auto', height: ismob ? 'auto' : '70px' }"
    />
    <div class="center-btn" v-if="ismob && !navigator">
      <!-- <el-button type="primary" plain @click="openWxminpg">跳转无感登录</el-button> -->
      <img src="../assets/minipg-backg-content.png" alt="" style="position: relative" />
      <button class="jump-btn" @click="openWxminpg">
        前往微信认证 <i class="el-icon-arrow-right el-icon--right"></i>
      </button>
    </div>

    <div class="centerContent" :style="{ width: ismob ? '440px' : '840px' }" v-if="!ismob">
      <div class="leftImg" :style="{ backgroundImage: 'url(' + imgurl + ')' }">
        <span>欢迎登录智慧校园系统。</span>
      </div>
      <div class="rightLog">
        <login :logfct="logfct"></login>
      </div>
      <div class="changeLogFct">
        <div @click="changelogin">
          <el-tooltip class="item" v-if="logfct" effect="dark" content="二维码登录" placement="right-start">
            <img v-if="logfct" class="img1" :src="require('../assets/qcode.png')" />
          </el-tooltip>
          <el-tooltip class="item" v-if="!logfct" effect="dark" content="账号密码登录" placement="right-start">
            <img v-if="!logfct" class="img2" :src="require('../assets/computer.png')" />
          </el-tooltip>
        </div>
      </div>
    </div>
    <div style="color: #c72828; width: 94%; margin: auto; position: relative; top: 17vh" v-if="!ismob">
      严禁在互联网非涉密平台处理传输国家秘密，请确认上传的文件资料不涉及国家秘密
    </div>

    <div class="themeClass" v-if="!ismob">
      <el-dropdown trigger="click">
        <span class="el-dropdown-link"> {{ theme }}<i class="el-icon-arrow-down el-icon--right"></i> </span>
        <el-dropdown-menu slot="dropdown" placement="top-start">
          <el-dropdown-item @click.native="changeTheme(0)">季节跟随</el-dropdown-item>
          <el-dropdown-item @click.native="changeTheme(1)">暖春</el-dropdown-item>
          <el-dropdown-item @click.native="changeTheme(2)">热夏</el-dropdown-item>
          <el-dropdown-item @click.native="changeTheme(3)">金秋</el-dropdown-item>
          <el-dropdown-item @click.native="changeTheme(4)">凛冬</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div v-else></div>

    <p class="version" @click="toggleVc">V2.2.5.7 build-241217</p>
  </div>
</template>
<script>
import login from "./login";
export default {
  data() {
    return {
      activeName: "one",
      publiPath: process.env.BASE_URL,
      logfct: false,
      theme: "暖春",
      imgurl: "",
      navigator: false,
      isIos: "",
    };
  },
  computed: {
    ismob() {
      return window.screen.width < 500;
    },
  },
  methods: {
    changelogin() {
      this.logfct = !this.logfct;
    },
    changeTheme(index) {
      // console.log(index);
      switch (index) {
        case 0:
          this.theme = "季节跟随";
          var date = new Date();
          this.isMonth(date.getMonth());
          break;
        case 1:
          this.theme = "暖春";
          this.imgurl = require("../assets/themeImg/logimg_1.png");
          break;
        case 2:
          this.theme = "热夏";
          this.imgurl = require("../assets/themeImg/logimg_2.png");
          break;
        case 3:
          this.theme = "金秋";
          this.imgurl = require("../assets/themeImg/logimg_3.png");
          break;
        case 4:
          this.theme = "凛冬";
          this.imgurl = require("../assets/themeImg/logimg_4.png");
          break;
      }
      window.localStorage.setItem("themeIndex", index);
      // console.log(index);
    },
    isMonth(month) {
      switch (month) {
        case 3:
        case 4:
        case 5:
          this.imgurl = require("../assets/themeImg/logimg_1.png");
          break;
        case 6:
        case 7:
        case 8:
          this.imgurl = require("../assets/themeImg/logimg_2.png");
          break;
        case 9:
        case 10:
        case 11:
          this.imgurl = require("../assets/themeImg/logimg_3.png");
          break;
        case 12:
        case 1:
        case 2:
          this.imgurl = require("../assets/themeImg/logimg_4.png");
          break;
      }
    },
    getEnvironment() {
      //判断当前环境（微信/其他）
      let ua = navigator.userAgent.toLowerCase();
      this.navigator = ua.match(/MicroMessenger/i) == "micromessenger"; //true在微信浏览器中
      if (!(this.$route.query.extkey || this.getQueryVariable("extkey"))) this.navigator = false; //不是第三方认证场景

      this.isIos = ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/i);
    },
    //跳转微信小程序
    openWxminpg() {
      let path = this.$route.query.extjump ?? this.getQueryVariable("extjump");
      path = decodeURIComponent(path);
      let pbkey = this.$route.query.extkey ?? this.getQueryVariable("extkey");
      let extsign = this.$route.query.extsign ?? this.getQueryVariable("extsign");
      let timestamp = this.$route.query.extlgt ?? this.getQueryVariable("extlgt");
      if (!pbkey || !path || !extsign || !timestamp) {
        this.$message.error("缺少参数");
        return;
      }
      let query = { path, pbkey, extsign, timestamp };
      let queryString = Object.keys(query)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
        .join("&");
      queryString = encodeURIComponent(queryString);
      // console.log(query, queryString, "点击打开小程序");

      // queryString = queryString + "&path=" + path;
      // queryString = encodeURIComponent(queryString);
      // console.log(queryString);
      if (this.isIos) {
        location.href =
          "weixin://dl/business/?appid=wx7e523873b3a0998c&path=pages/index/index&query=" +
          queryString +
          "&env_version=release";
      } else {
        window.location.href =
          "weixin://dl/business/?appid=wx7e523873b3a0998c&path=pages/index/index&query=" +
          queryString +
          "&env_version=release";
      }

      //
      //env_version： 正式版为release，体验版为trial，开发版为develop，仅在微信外打开时生效
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },

    hasClass(obj, cls) {
      return obj.className.match(new RegExp("(\\s|^)" + cls + "(\\s|$)"));
    },
    //为指定的dom元素添加样式
    addClass(obj, cls) {
      if (!this.hasClass(obj, cls)) obj.className += cls;
    },
    //如果存在(不存在)，就删除(添加)一个样式
    toggleClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        this.removeClass(obj, cls);
      } else {
        this.addClass(obj, cls);
      }
    },
    //删除指定dom元素的样式
    removeClass(obj, cls) {
      if (this.hasClass(obj, cls)) {
        var reg = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        obj.className = obj.className.replace(reg, "");
      }
    },
    toggleVc() {
      const nowTime = new Date().getTime();
      if (nowTime - this.lastClickTime < 500) {
        this.count++;
      } else {
        this.count = 0;
      }
      this.lastClickTime = nowTime;
      if (this.count >= 10) {
        let vconDom = document.getElementById("__vconsole");
        this.toggleClass(vconDom, "show");
        this.count = 0;
      }
    },
  },
  components: {
    login,
  },
  mounted() {
    this.getEnvironment();
    var theme = window.localStorage.getItem("themeIndex");
    if (theme) {
      if (theme == "0") {
        var date = new Date();
        this.isMonth(date.getMonth());
      } else {
        this.changeTheme(parseInt(theme));
      }
    } else {
      this.imgurl = require("../assets/themeImg/logimg_1.png");
    }
  },
};
</script>
<style scoped>
.home {
  background: #fff url("../assets/backg.png") no-repeat fixed bottom;
  background-size: 100% auto;
  height: 100vh;
}
.centerContent {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  height: 520px;
  background: #fff;
  margin: auto;
  position: relative;
  top: 15vh;
  border-radius: 40px;
}

.center-btn {
  width: 100%;
  height: 100vh;
  background: url("../assets/minipg-backg.png") no-repeat top center;
  background-size: 100% auto;
  overflow: hidden;
}
.center-btn > img {
  width: 80%;
  margin: 12vh auto;
  height: auto;
}
.center-btn > .btn {
  position: relative;
  bottom: 10px;
}

.leftImg {
  /* background: url("../assets/logimg.png") no-repeat content-box left bottom; */
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: left bottom;
  background-origin: content-box;
  height: 520px;
  width: 400px;
  position: absolute;
  left: -24px;
}
.leftImg span {
  color: #aaaaaa;
  position: absolute;
  letter-spacing: 4px;
  font-size: 12px;
  left: 50px;
  top: 80px;
}
.rightLog {
  width: 440px;
  height: 520px;
  position: absolute;
  right: 0px;
  border-bottom-right-radius: 40px;
  border-top-right-radius: 40px;
}
.changeLogFct {
  height: 70px;
  width: 70px;
  position: absolute;
  right: 0px;
  overflow: hidden;
}
.changeLogFct > div {
  height: 120px;
  width: 120px;
  position: absolute;
  bottom: 18px;
  left: 16px;
  transform: rotate(45deg);
  overflow: hidden;
}
.img1 {
  transform: rotate(-45deg);
  position: absolute;
  left: 30px;
  top: 98px;
  height: 70px;
  width: auto;
  border-top-right-radius: 10px;
}
.img2 {
  transform: rotate(-45deg);
  position: absolute;
  left: 40px;
  top: 90px;
  height: 40px;
  width: auto;
  border-top-right-radius: 10px;
}
.log {
  width: 500px;
  margin: 100px auto;
  font-family: "Microsoft YaHei";
}
.themeClass {
  position: fixed;
  top: 30px;
  right: 50px;
  cursor: pointer;
}
.version {
  position: fixed;
  bottom: 10px;
  width: 100%;
  text-align: center;
  color: #e6e6e6;
  font-size: 14px;
  z-index: 0;
}

.jump-btn {
  width: 200px;
  /* height: 30px; */
  border: none;
  outline: none;
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
  /* margin-left: 10px; */
  border-radius: 3px;
  font-size: 18px;
  cursor: pointer;
  /* z-index: 99999; */
  position: relative;
  border-radius: 26px;
  padding: 16px 23px;
}
</style>
<style>
.logo {
  /* width: 200px; */
  left: 30px;
  position: absolute;
  margin-top: 10px;
}
</style>
